import MainPage from "./Pages/MainPage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SignUp from "./SharedComponents/SignUp";
import Login from "./SharedComponents/Login";
import AboutUs from "./SharedComponents/AboutUs";
import WizardPage from "./Pages/WizardPage";
import PlaceDetail from "./SharedComponents/PlaceDetail";
import ScrollToTop from "./SharedComponents/ScrollToTop";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import useUserStore from './store/userStore';
import SearchResultsPage from "./SharedComponents/SerachResultPage";
import AllPlacesByCategory from "./SharedComponents/AllPlacesByCategory";
import AllPlans from "./SharedComponents/AllPlans";
import PlanDetail from "./SharedComponents/PlanDetail";
import Layout from "./SharedComponents/Layout";
import UserProfile from "./SharedComponents/UserProfile";
import CityPage from "./SharedComponents/CityPage";

function App() {
  const queryClient = new QueryClient();
  const [hydrated, setHydrated] = useState(false);

  // Zustand hydration check
  useEffect(() => {
    const unsub = useUserStore.persist.onFinishHydration(() => {
      setHydrated(true);
    });

    if (useUserStore.persist.hasHydrated()) {
      setHydrated(true);
    }
    return () => unsub?.();
  }, []);


  return (
    <QueryClientProvider client={queryClient}>

      <div className="App font-myYekanFaNum" dir="rtl">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<MainPage />} />
              <Route path="/userProfile" element={<UserProfile />} />
              <Route path="/places/:id" element={<PlaceDetail />} />
              <Route path="/plans/:id" element={<PlanDetail />} />
              <Route path="/search-results" element={<SearchResultsPage />} />
              <Route path="/places/category/:category" element={<AllPlacesByCategory />} />
              <Route path="/plans" element={<AllPlans />} />
              <Route path="/planner" element={<WizardPage />} />
              <Route path="/signUp" element={<SignUp />} />
              <Route path="/login" element={<Login />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/places/city/:city" element={<CityPage />} />
            </Route>
          </Routes>
          <ToastContainer position="top-center" closeButton={false} />
        </BrowserRouter>
      </div>
    </QueryClientProvider>
  );
}

export default App;
